import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { BlogPost } from '../../../mocks/blogPosts';

interface BlogFeaturedPostProps {
  post: BlogPost;
}

const BlogFeaturedPost = ({ post }: BlogFeaturedPostProps) => {
  return (
    <motion.article
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-2xl shadow-2xl overflow-hidden mb-12 md:mb-16"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
        <div className="relative h-[280px] md:h-[400px] lg:h-auto overflow-hidden">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute top-4 left-4 md:top-6 md:left-6">
            <span className="bg-[#D4AF37] text-white text-xs md:text-sm font-bold px-3 py-1.5 md:px-4 md:py-2 rounded-full shadow-lg">
              ⭐ Artigo em Destaque
            </span>
          </div>
        </div>

        <div className="p-6 md:p-8 lg:p-12 flex flex-col justify-center">
          <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
            <span
              className={`${post.categoryColor} text-white text-xs font-semibold px-2.5 py-1 md:px-3 rounded-full`}
            >
              {post.category}
            </span>
            <span className="text-xs md:text-sm text-neutral-500">{post.readTime}</span>
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-neutral-900 mb-3 md:mb-4 leading-tight font-['Poppins']">
            {post.title}
          </h2>

          <p className="text-neutral-600 text-sm md:text-lg mb-4 md:mb-6 leading-relaxed">
            {post.excerpt}
          </p>

          <div className="flex flex-wrap gap-1.5 md:gap-2 mb-4 md:mb-6">
            {post.tags.map((tag) => (
              <span
                key={tag}
                className="text-xs bg-neutral-100 text-neutral-700 px-2.5 py-1 md:px-3 rounded-full"
              >
                #{tag}
              </span>
            ))}
          </div>

          <div className="flex items-center gap-3 md:gap-4 text-xs md:text-sm text-neutral-500 mb-4 md:mb-6">
            <div className="flex items-center gap-1.5 md:gap-2">
              <i className="ri-calendar-line text-[#D4AF37]" />
              <span>{post.date}</span>
            </div>
          </div>

          <Link
            to={`/blog/${post.slug}`}
            className="inline-flex items-center gap-2 bg-[#D4AF37] text-white px-6 py-3 md:px-8 md:py-4 rounded-lg font-semibold hover:bg-[#C4A137] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer w-fit text-sm md:text-base"
          >
            <span>Ler Artigo Completo</span>
            <i className="ri-arrow-right-line text-lg md:text-xl" />
          </Link>
        </div>
      </div>
    </motion.article>
  );
};

export default BlogFeaturedPost;